<!--  -->
<template>
  <div class="book" @click="enterDetails(item)">
    <div class="promotionLabel" v-if="item.promotionLabel == 2">
      <p>{{ showTime }}</p>
    </div>
    <div class="left" v-if="item.productBookInfoVO">
      <img :src="item.productBookInfoVO.bookCover" />
    </div>
    <div class="right">
      <h1 class="title" v-if="item.productBookInfoVO">{{ item.productBookInfoVO.bookName }}</h1>
      <div class="teacher" v-if="item.productBookInfoVO">{{ teachers(item) }}</div>
      <p class="desc"  ref="desc" v-if="item.productBookInfoVO" :class="{ active: more === 1,all:more }">
        {{ item.productBookInfoVO.bookIntroduction }}
      </p>
      <div class="more" @click.stop.prevent="changeMore" v-if="more">
        {{ more === 1 ? '更多...' : '收起' }}
      </div>
      <ol class="foot">
        <!-- 售价 -->
        <div class="coursePrice">
          <p class="showPic">
            <template
              v-if="item.productDiscountRespVO && item.productDiscountRespVO.isGroupDiscount"
            >
              <b>¥</b>
              <span>{{ item.productDiscountRespVO.discountMinPrice }}</span>
            </template>
            <template v-else>
              <b v-if="item.sellPrice === 0 && !item.promotionLabel ? false : true">¥</b>
              <span :class="{ fontSty: item.sellPrice === 0 && !item.promotionLabel }">{{
                item.sellPrice === 0 && !item.promotionLabel ? '限时免费' : item.sellPrice
              }}</span>
            </template>
          </p>
          <del v-if="coursePriceDel(item)">￥{{ item.originalPrice }}</del>
        </div>
        <div class="addShopping" @click.stop.prevent="addBook($event, item)"></div>
      </ol>
    </div>
  </div>
</template>

<script>
import { replaceHyphens, timerYhqCount } from '@/utils/tools';

export default {
  components: {},
  data() {
    return {
      more: false,
      showTime: '',
      timers: null,
    };
  },
  props: {
    item: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {},
  watch: {},
  methods: {
    changeMore() {
      this.more = this.more === 1 ? 2 : 1;
    },
    addBook(event, item) {
      this.$emit('addBook', { event: event.target, item });
    },
    coursePriceDel(item) {
      return item.productDiscountRespVO.isGroupDiscount || item.promotionLabel;
    },
    // 进入详情
    enterDetails(courseInfo) {
      const { productId } = courseInfo;
      this.$router.push({
        path: '/studyBookExperience',
        query: {
          courseId: productId,
        },
      });
    },
    // 倒计时
    countTime() {
      const { acvitityEndTime } = this.item;
      if (!acvitityEndTime) return;
      // 当前时间戳
      const now = new Date().getTime();
      // 结束时间戳
      const end = new Date(replaceHyphens(acvitityEndTime)).getTime();
      // 做判断当倒计时结束时都为0
      if (now >= end) {
        this.showTime = null;
        return;
      }
      // 用结束时间减去当前时间获得倒计时时间戳
      let temp = end - now + 1000;
      this.timers = setInterval(() => {
        temp -= 1000;
        if (temp > 0) {
          this.showTime = timerYhqCount(temp, 1);
        } else {
          this.showTime = null;
          clearInterval(this.timers);
        }
      }, 1000);
    },
    teachers(data) {
      const arr =
        data?.teacherRespVOS?.map((item) => {
          return item.name;
        }) || [];
      return arr.toString();
    },
  },
  created() {},
  mounted() {
    this.$nextTick(() => {
      const divHeight = this.$refs?.desc?.offsetHeight;
      console.log('DIV的高度是：', divHeight);
      this.more = divHeight > 36 ? 1 : 0;
      this.countTime();
    });
  },
};
</script>
<style lang="scss" scoped>
.book {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;
  box-sizing: border-box;
  width: 591px;
  min-height: 290px;
  margin-bottom: 22px;
  padding: 22px;
  background: #fff;
  border-radius: 14px;
  .promotionLabel {
    position: absolute;
    top: 0;
    left: 0;
    width: 216px;
    height: 36px;
    background: url('https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/studyBook/label.png');
    background-size: 100%;
    p {
      padding-right: 5px;
      color: #774d2d;
      font-weight: 500;
      font-size: 18px;
      line-height: 36px;
      text-align: right;
    }
  }
  .left {
    flex-shrink: 0;
    width: 185px;
    height: 246px;
    margin-right: 14px;
    border-radius: 14px;
    img {
      width: 185px;
      height: 246px;
      border-radius: 14px;
    }
  }
  .right {
    //  height: 246px;
     position: relative;
    .title {
      width: 350px;
      padding-bottom: 7px;
      overflow: hidden;
      color: #333;
      font-weight: 500;
      font-size: 29px;
      line-height: 40px;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
    .teacher {
      color: #999;
      font-weight: 400;
      font-size: 22px;
      line-height: 31px;
    }
    .desc {
      margin-top: 11px;
      margin-bottom: 98px;
      // overflow: hidden;
      color: #333;
      font-weight: 400;
      font-size: 22px;
      line-height: 31px;
      word-break: break-all;
    }
    .desc.all{
      margin-bottom: 0;
    }
    .desc.active {
      height: 65px;
      overflow: hidden;
    }
    .more {
        margin-bottom: 98px;
      color: #ff7f41;
      font-weight: 400;
      font-size: 22px;
    }
    .sale {
      display: flex;
      align-items: center;
      justify-content: space-between;
    }
  }
  .foot {
    position: absolute;
    bottom: 0;
    left: 0;
    display: flex;
    align-content: center;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    height: 51px;
    padding-top: 14px;
  }
  .coursePrice {
    position: relative;
    top: -2px;
    display: flex;
    align-items: baseline;
    del {
      padding-left: 7px;
      color: #ccc;
      font-size: 18px;
    }
    .showPic {
      b {
        margin: 0 4px;
        color: #ff3938;
        font-weight: 500;
        font-size: 25px;
      }
      span {
        color: #ff3938;
        font-weight: bold;
        font-size: 36px;
      }
      .fontSty {
        font-size: 30px;
      }
    }
  }
  .addShopping {
    flex-shrink: 0;
    width: 72px;
    height: 43px;
    background: url('https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/studyBook/shopping-btn2.png')
      no-repeat;
    background-size: 100%;
  }
}
</style>
